import { PDFDocument } from 'pdf-lib'
import { MAX_PDF_FILE_SIZE } from 'apps/formsCreationKit/lib/constants'

export const getDocumentBuffer = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsArrayBuffer(file)
  })

const checkIfEncrypted = async documentBuffer => {
  try {
    await PDFDocument.load(documentBuffer)
    return false
  } catch (e) {
    return e.message.includes('is encrypted')
  }
}
  
const checkIfValidPdf = file => {
  if (!file) return false

  const validMimeType = file.type === 'application/pdf'
  const validExtension = file.name.toLowerCase().endsWith('.pdf')
  const validSize = file.size <= MAX_PDF_FILE_SIZE
  return validMimeType && validExtension && validSize
}

// returns a promise that resolves to a blob URL
// for the PDF file, or rejects with an error message
export const convertPdftoBlobUrl = async (file, preloadedBuffer = null) => {
  try {
    const documentBuffer = preloadedBuffer ?? await getDocumentBuffer(file)
    const isValidPdf = checkIfValidPdf(file)
    const isEncrypted = isValidPdf
      ? await checkIfEncrypted(documentBuffer)
      : false

    if (!isValidPdf) {
      if (file.size > MAX_PDF_FILE_SIZE) {
        throw new Error('Files cannot be larger than 25MB')
      }
      throw new Error('Uploaded file must be a PDF')
    } else if (isEncrypted) {
      throw new Error('Cannot upload encrypted PDFs')
    } else {
      return URL.createObjectURL(file)
    }
  } catch (error) {
    const { message = 'Something went wrong' } = error
    throw new Error(message)
  }
}
